import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import cyan from '@material-ui/core/colors/cyan';

const playbackRates = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2];

class PlaybackRateSelector extends React.Component {
  state = {
    open: false,
    anchorEl: null,
  };
  handleClick = (e) => {
    e.preventDefault();
    this.props.onOverlayFixed(true);
    this.props.onOpenMenu(true);
    this.setState({
      open: true,
      anchorEl: e.currentTarget
    });
  };
  handleClose = (e) => {
    this.setState({
      open: false,
      anchorEl: null
    });
    this.props.onOverlayFixed(false);
    this.props.onOpenMenu(false);
  };
  render = () => {
    const overlay = this.props.overlay;
    if (!overlay) {
      return (<div/>);
    }
    const { anchorEl } = this.state;
    const menuItems = playbackRates.map(rate => {
      return (<MenuItem
        style={(this.props.currentPlaybackRate  === rate) ? {backgroundColor: cyan[400]} : {}}
        onClick={_ => this.props.onChangePlaybackRate(rate)}
      >
      {(rate  === 1) ? '標準': rate.toString()}
      </MenuItem>);
    });

    return (
      <div
        id="playback-rate-selector"
        hidden={this.props.isFullscreen}
      >
        <Button
          variant="text"
          aria-owns={anchorEl ? 'playback-rate-menu' : undefined}
          aria-haspopup="true"
          style={{color: 'white', minWidth: '36px', backgroundColor:'rgba(0, 0, 0, 0.6)'}}
          onClick={this.handleClick}
        >
          速度
        </Button>
        <Menu
          id="playback-rate-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          {menuItems}
        </Menu>
      </div>
    );
  }
};
export default PlaybackRateSelector;



// WEBPACK FOOTER //
// ./src/components/PlaybackRateSelector.js